import React, { Component } from 'react';
import { getDashboardUrl } from './lib/functions';


export default class ErrorMessage extends Component {
    constructor(props) {
        super(props);

        this.messages = {
            1: {
                message : '<p>Visual Builder can not be loaded. Please check that you are logged in GrooveKart Dasboard.</p><p>If your store is disabled <strong>Settings -> Disable My Store</strong> check that you have saved correct IP.</p>',
                cta : {
                    label : 'Go to settings',
                    url : '/administration/'
                }
            }
        }
    }

    render() {
        return (
            <div className="error-msg-container">
                <div className="error-mg-box">
                    <div dangerouslySetInnerHTML={{ __html: this.messages[this.props.type].message}}></div>
                    <a href="/administration/" target="_blank">{this.messages[this.props.type].cta.label}</a>
                </div>
            </div>
        )
    }
}